import gql from 'graphql-tag';

export default gql`
  query getThePlaceSlidesByType($type: String!) {
    getThePlaceSlidesByType(type: $type) {
      id
      img_media_desktop
      img_media_mobile
      order
      type
      detail {
        title
        content
        language_code
      }
    }
  }
`;
